import siteContextStore from '@/shared/content/site-context.store';
import { StoreContextFooterViewModel, StoreContextSiteContextModel, LinkModel, StoreContextTopNavigationModel, Country } from '@/types/StoreContextContentServerContract';

class SiteContextService {
    private get settings(): StoreContextSiteContextModel {
        return siteContextStore.settings as StoreContextSiteContextModel;
    }

    get country(): Country {
        return this.settings.country;
    }

    get frontPageUrl(): string {
        return this.settings.frontPageUrl;
    }

    get loginLink(): LinkModel {
        return this.settings.loginLink;
    }

    get topNavigation(): StoreContextTopNavigationModel {
        return this.settings.topNavigation;
    }

    public get footer(): StoreContextFooterViewModel {
        return this.settings?.footer ?? {
            columns: [],
        };
    }
}

export default new SiteContextService();
